export default "__VITE_ASSET__DtwhQeCC__"